import React, { useEffect } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "src/providers/ThemeProvider";
import store from "src/store";
import Router from "src/ui/navigation/Router";

import { SubscriptionExpirationBanner } from "@dashboard/workspaces/components/SubscriptionExpirationBanner/SubscriptionExpirationBanner";
import { withMetaDescription } from "@navigation/utils/withMetaDescription";

import AnalyticService from "./services/analyticService";
import { Navigation } from "./ui/navigation/Navigation";

const App = () => {
    useEffect(() => {
        AnalyticService.initialize();
    }, []);

    const domain = window.location.hostname;
    if (domain === "hub.jkc.emteria.com") {
        // temporary redirect to new Kenwood URL
        window.location.href = "https://mdm.kenwood.com";
    }

    return (
        <ReduxProvider store={store}>
            <BrowserRouter basename={import.meta.env.BASE_URL}>
                <ThemeProvider>
                    <SubscriptionExpirationBanner />
                    <ToastContainer style={{ top: "74px", right: "10px" }} theme="colored" stacked limit={5} />
                    <Navigation>
                        <Router />
                    </Navigation>
                </ThemeProvider>
            </BrowserRouter>
        </ReduxProvider>
    );
};

export default withMetaDescription(App, {});
